import React from 'react';
import PropTypes from 'prop-types';
import SrDarkModal from 'client/components/SrDarkModal';
import SrModalContent from 'client/components/SrModalContent';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrFlex from 'client/components/SrFlex';
import SrTable from 'client/components/SrTable';
import moment from 'moment';

const SrInventoryItemScanLogsModal = ({
  itemName,
  itemSerialNumber,
  itemStatus,
  itemScansLogs,
  onClose,
}) => {
  return (
    <SrDarkModal onClose={onClose}>
      <SrModalContent style={{ width: 553, marginTop: 4 }}>
        <SrBox>
          <SrText
            font="greycliff"
            fontSize="26px"
            weight="800"
            lineHeight="36px"
            letterSpacing="0.5"
          >
            Item Scans
          </SrText>
        </SrBox>
        <SrBox marginTop="8px">
          <SrText font="greycliff" fontSize="16px" weight="600" color="grey">
            {itemName} - #{itemSerialNumber}
          </SrText>
        </SrBox>
        <SrFlex marginTop="8px">
          <SrBox marginLeft="5px" minWidth="200px">
            <SrText font="greycliff" weight="700" color="grey">
              Current Status: {itemStatus}
            </SrText>
          </SrBox>
        </SrFlex>
        <SrBox marginTop="17px" maxHeight="30vh" overflowX="scroll">
          <SrTable
            headers={[
              { content: 'Date' },
              { content: 'Scanned By' },
              { content: 'Item Status' },
              { content: 'Location' },
            ]}
            rows={itemScansLogs.map((scan) => ({
              cells: [
                {
                  content: moment(scan.createdAt).format('MM/DD/YY hh:mm A'),
                  style: {
                    fontSize: '12px',
                  },
                },
                {
                  content: scan.name,
                  style: {
                    fontSize: '12px',
                  },
                },
                {
                  content: scan.status,
                  style: {
                    fontSize: '12px',
                  },
                },
                {
                  content: `${scan.latitude}, ${scan.longitude}`,
                  style: {
                    fontSize: '12px',
                  },
                },
              ],
            }))}
          />
        </SrBox>
      </SrModalContent>
    </SrDarkModal>
  );
};

SrInventoryItemScanLogsModal.propTypes = {
  itemScansLogs: PropTypes.array,
  itemName: PropTypes.string,
  itemSerialNumber: PropTypes.string,
  itemStatus: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

export default SrInventoryItemScanLogsModal;
